// extracted by mini-css-extract-plugin
export default {"release-notes-collapsible":"y_cp","header-collapsible":"y_cq"};